import type { RouteType } from '~constants/routes/Routes.types';
import RoutesPageLayout from '~constants/routes/RoutesPageLayout';
import InvitationView from '~views/user/InvitationView';
import LoginView from '~views/user/LoginView';
import SignupView from '~views/user/SignupView';

const PublicRoutes = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  INVITATION: '/invitation',
};

const publicRoutes: Array<RouteType> = [
  {
    path: PublicRoutes.LOGIN,
    Component: LoginView,
    LayoutComponent: RoutesPageLayout.PUBLIC_PAGE_LAYOUT,
  },
  {
    path: PublicRoutes.SIGNUP,
    Component: SignupView,
    LayoutComponent: RoutesPageLayout.PUBLIC_PAGE_LAYOUT,
  },
  {
    path: PublicRoutes.INVITATION,
    Component: InvitationView,
    LayoutComponent: RoutesPageLayout.PUBLIC_PAGE_LAYOUT,
  },
];

export default publicRoutes;
export { PublicRoutes };
